import clsx from 'clsx';
import ResponsiveImage from 'components/common/ResponsiveImage';
import Markdown from 'components/common/MarkdownV2';
import MarkdownWithBullet from 'components/common/MarkdownWithBulletV2';
import { imageDimension } from 'lib/helper';
import styles from './ProductListing.module.scss';

interface ProductItemDefaultProps {
  titleColor: string;
  title: string;
  subtitleColor: string;
  subtitle: string;
  bulletColor?: string;
  image: any;
  content: string | null;
}

function ProductItemDefault({
  titleColor,
  title,
  subtitleColor,
  subtitle,
  bulletColor,
  image,
  content,
}: Readonly<ProductItemDefaultProps>) {
  const dimension =
    image?.desktopImage &&
    imageDimension(image.desktopImage.width, image.desktopImage.height);

  return (
    <div className="flex flex-row flex-wrap w-full">
      {image?.desktopImage && (
        <div
          className={clsx(
            'flex-none block overflow-hidden mr-[20px] max-h-[9.125rem]',
            dimension === 'vertical' ? 'min-w-[5.813rem]' : 'min-w-[9.4rem]',
            dimension === 'vertical' ? 'min-h-[9.125rem]' : 'min-h-[5.875rem]',
            styles.productListing__image
          )}
        >
          <ResponsiveImage
            src={image.desktopImage}
            srcMobile={image.mobileImage}
            artDirection={image.artDirection}
            width={image.desktopImage.width}
            height={image.desktopImage.height}
          />
        </div>
      )}
      <div className="block flex-1">
        <div className="text-[18px] font-bold leading-[24px] text-ellipsis overflow-hidden line-clamp-2">
          <Markdown
            md={title}
            textAlign="left"
            textColor={titleColor}
            className="justify-center text-center text-[18px] font-[700]"
          />
        </div>
        <div className="text-[18px] font-bold leading-[24px] text-ellipsis overflow-hidden line-clamp-2">
          <Markdown
            md={subtitle}
            textAlign="left"
            textColor={subtitleColor}
            className="justify-center text-center text-[16px] font-[400] leading-[1.375rem]"
          />
        </div>
      </div>
      <div className="flex-none w-full mt-[1.063rem]">
        <div className={styles.productListing__text}>
          <MarkdownWithBullet
            bulletColor={bulletColor as string}
            subtitle={content ?? ''}
            align="left"
            subtitleColor="#4f4b66"
          />
        </div>
      </div>
    </div>
  );
}

export default ProductItemDefault;
